import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useRecoilValueLoadable } from 'recoil';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import Header from '../../shared-components/header/Header';
import { ordersSelector } from '../../../atoms/Selectors';

require('dayjs/locale/es');

dayjs.locale('en');
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

function Orders() {
  const orders = useRecoilValueLoadable(ordersSelector);
  const { t } = useTranslation();

  return (
    <div>
      <Header />
      <div>{orders && orders.length}</div>
      <div className="flex flex-col md:flex-row flex-1 overflow-hidden">
        {t('test_orders')}
      </div>
    </div>
  );
}

export default Orders;
